'use strict';

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var SvgIcon = require('@mui/material/SvgIcon');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var SvgIcon__default = /*#__PURE__*/_interopDefaultLegacy(SvgIcon);

var Mapper = function Mapper(props) {
  return /*#__PURE__*/React__default["default"].createElement(SvgIcon__default["default"], _rollupPluginBabelHelpers["extends"]({
    viewBox: "0 0 270 250"
  }, props), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M186.5 202.5h-103c-14.3 0-26-11.7-26-26v-44.7c0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8v44.7c0 7.9 6.4 14.4 14.4 14.4h103c7.9 0 14.4-6.4 14.4-14.4V148c0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8v28.4c0 14.4-11.7 26.1-26 26.1zM206.7 124c-3.2 0-5.8-2.6-5.8-5.8V73.5c0-7.9-6.4-14.4-14.4-14.4h-103c-7.9 0-14.4 6.4-14.4 14.4V102c0 3.2-2.6 5.8-5.8 5.8-3.2 0-5.8-2.6-5.8-5.8V73.5c0-14.3 11.7-26 26-26h103c14.3 0 26 11.7 26 26v44.7c0 3.2-2.6 5.8-5.8 5.8z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M48.4 144.5c-1.5 0-2.9-.6-4.1-1.7-2.3-2.2-2.3-5.9-.1-8.2l14.5-14.8.1-.1c.5-.5 1.1-.9 1.7-1.2.8-.3 1.6-.5 2.4-.5.8 0 1.6.2 2.4.5.6.3 1.2.7 1.7 1.2l.1.1 14.5 14.8c2.2 2.3 2.2 6-.1 8.2-2.3 2.2-6 2.2-8.2-.1L63 132.1l-10.3 10.6c-1.2 1.2-2.8 1.8-4.3 1.8zM207.1 132c-.8 0-1.6-.2-2.3-.5-.6-.3-1.2-.7-1.8-1.2l-.1-.1-14.5-14.8c-2.2-2.3-2.2-6 .1-8.2 2.3-2.2 6-2.2 8.2.1l10.3 10.6 10.3-10.6c2.2-2.3 5.9-2.3 8.2-.1 2.3 2.2 2.3 5.9.1 8.2l-14.5 14.8c-.5.5-1.1 1-1.8 1.2-.6.4-1.4.6-2.2.6z"
  }));
};
Mapper.propTypes = SvgIcon__default["default"].propTypes;

module.exports = Mapper;
